module.exports = __webpack_public_path__ + "files/b646999346587d81f07d506ca7f38afc.png";